var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": _vm.layoutMode,
          immediate: false,
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "table-header",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            _vm.showAccountCell
              ? {
                  key: "colMemberAccount",
                  fn: function ({ row }) {
                    return [
                      _c("MemberAccountCell", {
                        attrs: {
                          row: row,
                          username: row.username,
                          uid: row.uid,
                          "vip-level": row.vip_level,
                          "default-detail-tab-type": "withdrawAccount",
                        },
                      }),
                    ]
                  },
                }
              : null,
            {
              key: "colCardNo",
              fn: function ({ row }) {
                return [_c("div", [_vm._v(_vm._s(row.card_no || "-"))])]
              },
            },
            {
              key: "colCreatedAt",
              fn: function ({ row }) {
                return [
                  _vm._v(_vm._s(_vm._f("formatTimestamp")(row.created_at))),
                ]
              },
            },
            {
              key: "colActions",
              fn: function ({ row }) {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.handleEdit(row)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "danger-button",
                      attrs: { size: "mini", type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.handleDelete(row.id)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c("BankAccountFormDialog", {
        attrs: {
          visible: _vm.formDialogVisible,
          "is-edit": _vm.isEdit,
          "form-data": _vm.formData,
        },
        on: {
          "update:visible": function ($event) {
            _vm.formDialogVisible = $event
          },
          success: _vm.handleFormSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }